import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import Title from 'layouts/page/Title'

export default function Badges (props) {
  return (
    <AdminPageWithSmartview>
      <Title />
    </AdminPageWithSmartview>
  )
}
